module.exports = __webpack_public_path__ + "img/tablet-pains.0de3fcb2.webp";